export default __webpack_public_path__ + "static/pilot-b60384c29a2a9e716a1dabf768ab15ad.jpg";